/* YYorrZ — modern floating Add to Bag behavior */
(function(){
  'use strict';

  function enhance(section){
    if(!section || section.dataset.yyzModernStickyReady==='true') return;

    var dock=document.querySelector('[data-yyz-mobile-dock]');
    var nativeAdd=section.querySelector('[data-add-to-cart]');
    if(!dock || !nativeAdd) return;

    section.dataset.yyzModernStickyReady='true';
    dock.setAttribute('data-yyz-modern-sticky-ready','true');

    var action=dock.querySelector('.yyz-mobile-dock__button');
    var cookie=document.getElementById('CookieBanner');
    var shown=false;

    function keepDockAvailable(){
      if(dock.hasAttribute('hidden')) dock.removeAttribute('hidden');
    }

    function syncCookieOffset(){
      var offset=0;
      if(cookie && !cookie.hidden){
        var rect=cookie.getBoundingClientRect();
        if(rect.height>0) offset=Math.ceil(rect.height)+12;
      }
      dock.style.setProperty('--yyz-cookie-offset',offset+'px');
    }

    function setShown(next){
      if(shown===next) return;
      shown=next;
      dock.classList.toggle('is-modern-visible',next);
      dock.setAttribute('aria-hidden',next?'false':'true');
      if(action) action.tabIndex=next?0:-1;
    }

    function render(){
      keepDockAvailable();
      syncCookieOffset();
      var rect=section.getBoundingClientRect();
      var sectionActive=rect.bottom>110 && rect.top<window.innerHeight;
      var passedIntro=rect.top<-120;
      setShown(sectionActive && passedIntro);
    }

    keepDockAvailable();
    dock.setAttribute('aria-hidden','true');
    if(action) action.tabIndex=-1;

    var dockObserver=new MutationObserver(function(){
      keepDockAvailable();
      window.requestAnimationFrame(render);
    });
    dockObserver.observe(dock,{attributes:true,attributeFilter:['hidden']});

    if(cookie){
      var cookieObserver=new MutationObserver(function(){window.requestAnimationFrame(render);});
      cookieObserver.observe(cookie,{attributes:true,attributeFilter:['hidden']});
      if('ResizeObserver' in window){
        new ResizeObserver(function(){window.requestAnimationFrame(syncCookieOffset);}).observe(cookie);
      }
    }

    var rootObserver=new MutationObserver(function(){window.requestAnimationFrame(render);});
    rootObserver.observe(document.documentElement,{attributes:true,attributeFilter:['class']});

    var ticking=false;
    function requestRender(){
      if(ticking) return;
      ticking=true;
      window.requestAnimationFrame(function(){ticking=false;render();});
    }

    window.addEventListener('scroll',requestRender,{passive:true});
    window.addEventListener('resize',requestRender,{passive:true});
    render();
  }

  function init(root){
    var scope=root||document;
    var sections=[];
    if(scope.matches && scope.matches('[data-product-section]')) sections.push(scope);
    if(scope.querySelectorAll) scope.querySelectorAll('[data-product-section]').forEach(function(section){sections.push(section);});
    sections.forEach(enhance);
  }

  function boot(){window.requestAnimationFrame(function(){init(document);});}
  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',boot,{once:true});
  else boot();
  document.addEventListener('shopify:section:load',function(event){window.requestAnimationFrame(function(){init(event.target);});});
})();

/* YYorrZ — product-page CLOSE control */
(function(){
  'use strict';

  function sameOriginReferrer(){
    if(!document.referrer) return false;
    try{return new URL(document.referrer,window.location.href).origin===window.location.origin}catch(e){return false}
  }

  function fallbackUrl(){
    var root='/';
    if(window.Shopify&&Shopify.routes&&Shopify.routes.root) root=Shopify.routes.root;
    if(root.charAt(root.length-1)!=='/') root+='/';
    return root+'collections/all';
  }

  function enhanceClose(section){
    if(!section || section.querySelector('[data-yyz-product-close]')) return;
    var info=section.querySelector('.product-info');
    if(!info) return;

    var button=document.createElement('button');
    button.type='button';
    button.className='yyz-product-close';
    button.setAttribute('data-yyz-product-close','');
    button.setAttribute('aria-label','Close product page');
    button.textContent='CLOSE';

    button.addEventListener('click',function(){
      if(sameOriginReferrer() && window.history.length>1){
        window.history.back();
        return;
      }
      window.location.assign(fallbackUrl());
    });

    section.insertBefore(button,section.firstChild);
  }

  function initClose(root){
    var scope=root||document;
    if(scope.matches&&scope.matches('[data-product-section]')) enhanceClose(scope);
    if(scope.querySelectorAll) scope.querySelectorAll('[data-product-section]').forEach(enhanceClose);
  }

  function bootClose(){window.requestAnimationFrame(function(){initClose(document);});}
  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',bootClose,{once:true});
  else bootClose();
  document.addEventListener('shopify:section:load',function(event){window.requestAnimationFrame(function(){initClose(event.target);});});
})();

/* YYorrZ — Shipping & Delivery and Returns & Refunds are independent sections. */
(function(){
  'use strict';

  function closeOtherItems(root,except){
    root.querySelectorAll('[data-accordion-item]').forEach(function(item){
      var trigger=item.querySelector('[data-accordion-trigger]');
      var panel=item.querySelector('[data-accordion-panel]');
      if(!trigger||!panel||trigger===except) return;
      trigger.setAttribute('aria-expanded','false');
      panel.hidden=true;
    });
  }

  function splitPolicies(section){
    if(!section || section.dataset.yyzPolicySplit==='true') return;
    var root=section.querySelector('[data-product-accordion]');
    if(!root) return;

    var returnBlock=root.querySelector('.accordion-panel__return');
    var shippingItem=returnBlock&&returnBlock.closest('[data-accordion-item]');
    if(!shippingItem) return;

    var shippingTrigger=shippingItem.querySelector('[data-accordion-trigger]');
    var shippingLabel=shippingTrigger&&shippingTrigger.querySelector('span:first-child');
    if(shippingLabel) shippingLabel.textContent='SHIPPING & DELIVERY';

    var returnsItem=document.createElement('div');
    returnsItem.className='accordion-item yyz-returns-refunds';
    returnsItem.setAttribute('data-accordion-item','');
    returnsItem.innerHTML='<button type="button" class="accordion-trigger" aria-expanded="false" data-accordion-trigger><span>RETURNS &amp; REFUNDS</span><span class="accordion-icon" aria-hidden="true">+</span></button><div class="accordion-panel" data-accordion-panel hidden><div class="accordion-panel__inner rte"></div></div>';

    var returnsInner=returnsItem.querySelector('.accordion-panel__inner');
    while(returnBlock.firstChild) returnsInner.appendChild(returnBlock.firstChild);
    returnBlock.remove();
    shippingItem.insertAdjacentElement('afterend',returnsItem);

    var returnsTrigger=returnsItem.querySelector('[data-accordion-trigger]');
    var returnsPanel=returnsItem.querySelector('[data-accordion-panel]');

    returnsTrigger.addEventListener('click',function(event){
      event.preventDefault();
      event.stopPropagation();
      var willOpen=returnsTrigger.getAttribute('aria-expanded')!=='true';
      closeOtherItems(root,returnsTrigger);
      returnsTrigger.setAttribute('aria-expanded',willOpen?'true':'false');
      returnsPanel.hidden=!willOpen;
    });

    section.dataset.yyzPolicySplit='true';
  }

  function initPolicies(root){
    var scope=root||document;
    if(scope.matches&&scope.matches('[data-product-section]')) splitPolicies(scope);
    if(scope.querySelectorAll) scope.querySelectorAll('[data-product-section]').forEach(splitPolicies);
  }

  function bootPolicies(){window.requestAnimationFrame(function(){initPolicies(document);});}
  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',bootPolicies,{once:true});
  else bootPolicies();
  document.addEventListener('shopify:section:load',function(event){window.requestAnimationFrame(function(){initPolicies(event.target);});});
})();

/* YYorrZ 7.3.9 — reference product UI, fixed size-guide CLOSE, and modern footer hover. */
(function(){
  'use strict';

  var STYLE_ID='yyz-reference-pdp-739';
  var css='\
body.yyz-size-guide-open{overflow:hidden!important;}\
body .product-page.product-showroom .product-info>.yyz-product-close{position:static!important;top:auto!important;left:auto!important;right:auto!important;z-index:auto!important;margin:0 0 clamp(28px,3vw,46px)!important;padding:8px 0 5px!important;transform:none!important;}\
@media(min-width:1100px){body .product-page.product-showroom .product-info{padding-top:clamp(26px,2.2vw,38px)!important;}}\
@media(max-width:640px){body .product-page.product-showroom .product-info>.yyz-product-close{position:static!important;top:auto!important;left:auto!important;margin:0 0 24px!important;}}\
.product-page .product-option--color-reference .option-label{display:flex!important;flex-direction:column!important;align-items:flex-start!important;gap:6px!important;margin-bottom:12px!important;}\
.product-page .product-option--color-reference .option-selected-value{display:block!important;margin:0!important;color:var(--navy,#03256C)!important;font-size:.84rem!important;font-weight:560!important;letter-spacing:.01em!important;text-transform:none!important;}\
.product-page .product-option--color-reference .variant-boxes{display:flex!important;flex-wrap:wrap!important;gap:10px!important;}\
.product-page .product-option--color-reference .variant-box.variant-box--color-reference{position:relative!important;width:68px!important;min-width:68px!important;height:27px!important;min-height:27px!important;padding:3px!important;border:1px solid rgba(3,37,108,.32)!important;border-radius:2px!important;background:transparent!important;overflow:hidden!important;box-shadow:none!important;}\
.product-page .product-option--color-reference .variant-box.variant-box--color-reference:hover{border-color:var(--navy,#03256C)!important;transform:translateY(-1px)!important;}\
.product-page .product-option--color-reference .variant-box.variant-box--color-reference.is-selected,.product-page .product-option--color-reference .variant-box.variant-box--color-reference:has(input:checked){border:2px solid var(--navy,#03256C)!important;padding:2px!important;box-shadow:0 0 0 1px rgba(197,203,227,.9)!important;}\
.product-page .variant-box__color-chip{display:block!important;width:100%!important;height:100%!important;border-radius:0!important;background-color:#D8E3FF;background-repeat:no-repeat;background-position:center;background-size:cover;}\
.product-page .variant-box--color-reference .variant-box__text{position:absolute!important;width:1px!important;height:1px!important;padding:0!important;margin:-1px!important;overflow:hidden!important;clip:rect(0,0,0,0)!important;white-space:nowrap!important;border:0!important;}\
.product-page .product-option--size-reference .option-label{display:flex!important;align-items:baseline!important;flex-wrap:wrap!important;gap:8px 12px!important;}\
.product-page .product-option--size-reference .yyz-size-guide-trigger{appearance:none!important;border:0!important;border-bottom:1px solid currentColor!important;border-radius:0!important;background:transparent!important;color:rgba(3,37,108,.7)!important;padding:0 0 2px!important;margin:0!important;font:inherit!important;font-size:.82rem!important;font-style:italic!important;font-weight:450!important;letter-spacing:0!important;text-transform:none!important;cursor:pointer!important;transition:color .18s ease,opacity .18s ease!important;}\
.product-page .product-option--size-reference .yyz-size-guide-trigger:hover{color:var(--navy,#03256C)!important;}\
.product-page .product-option--size-reference .yyz-size-guide-trigger:focus-visible{outline:2px solid var(--cta,#FFD60A)!important;outline-offset:3px!important;}\
.yyz-size-guide-modal[hidden]{display:none!important;}\
.yyz-size-guide-modal{position:fixed!important;inset:0!important;z-index:10000!important;background:rgba(3,37,108,.18)!important;-webkit-backdrop-filter:blur(2px)!important;backdrop-filter:blur(2px)!important;}\
.yyz-size-guide__sheet{position:absolute!important;inset:0!important;overflow-y:auto!important;overscroll-behavior:contain!important;background:#fff!important;color:#111!important;scrollbar-width:thin!important;}\
.yyz-size-guide__close{position:fixed!important;top:clamp(18px,2.2vw,34px)!important;left:clamp(18px,2.2vw,34px)!important;z-index:10002!important;display:inline-flex!important;align-items:center!important;min-height:38px!important;padding:0 0 5px!important;border:0!important;border-bottom:1px solid transparent!important;border-radius:0!important;background:rgba(255,255,255,.94)!important;color:#111!important;font-family:var(--sans,Arial,sans-serif)!important;font-size:.68rem!important;font-weight:720!important;line-height:1!important;letter-spacing:.06em!important;text-transform:uppercase!important;cursor:pointer!important;}\
.yyz-size-guide__close:hover{border-bottom-color:currentColor!important;}\
.yyz-size-guide__close:focus-visible{outline:2px solid var(--navy,#03256C)!important;outline-offset:4px!important;}\
.yyz-size-guide__inner{width:min(1180px,calc(100% - 48px))!important;margin:0 auto!important;padding:clamp(118px,14vh,164px) 0 96px!important;}\
.yyz-size-guide__eyebrow{margin:0 0 12px!important;color:rgba(17,17,17,.55)!important;font-family:var(--sans,Arial,sans-serif)!important;font-size:.68rem!important;font-weight:650!important;letter-spacing:.12em!important;text-transform:uppercase!important;}\
.yyz-size-guide__title{margin:0 0 clamp(44px,6vw,72px)!important;color:#111!important;font-family:var(--serif,Georgia,serif)!important;font-size:clamp(1.45rem,2.2vw,2.1rem)!important;font-weight:500!important;line-height:1.1!important;}\
.yyz-size-guide__section{padding:28px 0!important;border-top:1px solid rgba(17,17,17,.72)!important;}\
.yyz-size-guide__section h3{margin:0 0 18px!important;color:#111!important;font-family:var(--serif,Georgia,serif)!important;font-size:1.08rem!important;font-weight:500!important;}\
.yyz-size-guide__content{max-width:880px!important;font-size:.96rem!important;line-height:1.65!important;}\
.yyz-size-guide__content table{width:100%!important;border-collapse:collapse!important;margin:10px 0 18px!important;}\
.yyz-size-guide__content th,.yyz-size-guide__content td{padding:12px 10px!important;border-bottom:1px solid rgba(17,17,17,.45)!important;text-align:left!important;}\
.yyz-size-guide__sizes{display:flex!important;flex-wrap:wrap!important;gap:0!important;border-top:1px solid rgba(17,17,17,.7)!important;border-left:1px solid rgba(17,17,17,.7)!important;width:max-content!important;max-width:100%!important;}\
.yyz-size-guide__size{min-width:74px!important;padding:13px 16px!important;border-right:1px solid rgba(17,17,17,.7)!important;border-bottom:1px solid rgba(17,17,17,.7)!important;text-align:center!important;font-size:.9rem!important;}\
.yyz-size-guide__measure{max-width:760px!important;margin:0!important;color:#333!important;font-size:.94rem!important;line-height:1.65!important;}\
@media(max-width:640px){.yyz-size-guide__inner{width:calc(100% - 32px)!important;padding:104px 0 72px!important;}.yyz-size-guide__close{top:14px!important;left:16px!important;}.yyz-size-guide__title{margin-bottom:38px!important;}.yyz-size-guide__size{min-width:64px!important;padding:11px 13px!important;}}\
.site-footer .footer-col a,.site-footer .footer-legal-links a{position:relative!important;display:inline-block!important;text-decoration:none!important;outline:none!important;background-image:linear-gradient(currentColor,currentColor)!important;background-repeat:no-repeat!important;background-position:0 100%!important;background-size:0 1px!important;transition:color .2s ease,background-size .28s cubic-bezier(.2,.7,.2,1),transform .2s ease!important;}\
.site-footer .footer-col a:hover,.site-footer .footer-legal-links a:hover{outline:none!important;border:0!important;box-shadow:none!important;background-size:100% 1px!important;transform:translateX(3px)!important;color:#000!important;}\
.site-footer .footer-col a:focus-visible,.site-footer .footer-legal-links a:focus-visible{outline:2px solid var(--navy,#03256C)!important;outline-offset:4px!important;background-size:100% 1px!important;}\
.site-footer .footer-social a{outline:none!important;transition:color .2s ease,opacity .2s ease,transform .2s ease!important;}\
.site-footer .footer-social a:hover{outline:none!important;box-shadow:none!important;transform:translateY(-2px)!important;opacity:.78!important;}\
.site-footer .footer-social a:focus-visible{outline:2px solid var(--cta,#FFD60A)!important;outline-offset:4px!important;}\
@media(prefers-reduced-motion:reduce){.product-page .variant-box--color-reference,.site-footer .footer-col a,.site-footer .footer-legal-links a,.site-footer .footer-social a{transition:none!important;}}\
';

  function injectStyles(){
    if(document.getElementById(STYLE_ID)) return;
    var style=document.createElement('style');
    style.id=STYLE_ID;
    style.textContent=css;
    document.head.appendChild(style);
  }

  function optionName(group){
    var input=group&&group.querySelector('input[data-variant-option],input[type="radio"]');
    if(!input) return '';
    var raw=input.getAttribute('name')||'';
    var match=raw.match(/options\[([^\]]+)\]/i);
    if(match&&match[1]) return match[1];
    var legend=group.querySelector('.option-label');
    if(!legend) return '';
    var clone=legend.cloneNode(true);
    clone.querySelectorAll('.option-selected-value,.yyz-size-guide-trigger').forEach(function(node){node.remove();});
    return (clone.textContent||'').trim();
  }

  function normalize(value){return String(value||'').trim().toLowerCase();}

  function fallbackColor(name){
    var n=normalize(name);
    var colors=[
      ['french blue','#4A6FA5'],['midnight blue','#172B4D'],['navy','#0B1D36'],['black','#181818'],
      ['off white','#F1EFE7'],['ivory','#F3EBDD'],['cream','#F6F1E8'],['white','#F8F8F5'],
      ['charcoal','#484A4D'],['grey','#92969B'],['gray','#92969B'],['silver','#C4C7CC'],
      ['olive','#697049'],['forest','#31513B'],['green','#4B7055'],['brown','#6E4B38'],['chocolate','#583B2E'],
      ['tan','#B98D67'],['camel','#B78A5B'],['beige','#D9CAB2'],['khaki','#B1A37A'],
      ['burgundy','#6E2433'],['wine','#742F3C'],['red','#A63838'],['pink','#D6A0AE'],
      ['purple','#756080'],['orange','#C7793B'],['yellow','#D3B43B'],['gold','#C4A36A'],['blue','#567FAE']
    ];
    for(var i=0;i<colors.length;i++) if(n.indexOf(colors[i][0])!==-1) return colors[i][1];
    return '#D8E3FF';
  }

  function readVariants(section){
    var node=section.querySelector('[data-product-variants-json]');
    if(!node) return [];
    try{
      var parsed=JSON.parse(node.textContent||'[]');
      return Array.isArray(parsed)?parsed:[];
    }catch(e){return [];}
  }

  function imageFromVariant(variant){
    if(!variant) return '';
    if(variant.featured_image){
      if(typeof variant.featured_image==='string') return variant.featured_image;
      if(variant.featured_image.src) return variant.featured_image.src;
    }
    if(variant.featured_media&&variant.featured_media.preview_image&&variant.featured_media.preview_image.src) return variant.featured_media.preview_image.src;
    if(variant.image){
      if(typeof variant.image==='string') return variant.image;
      if(variant.image.src) return variant.image.src;
    }
    return '';
  }

  function swatchImage(variants,position,value){
    var index=Math.max(0,(parseInt(position,10)||1)-1);
    for(var i=0;i<variants.length;i++){
      var variant=variants[i];
      var options=variant&&variant.options;
      if(options&&String(options[index])===String(value)){
        var image=imageFromVariant(variant);
        if(image) return image;
      }
    }
    return '';
  }

  function selectedInput(group){return group.querySelector('input[data-variant-option]:checked,input[type="radio"]:checked');}

  function updateSelectedLabel(group){
    var output=group.querySelector('[data-option-label],.option-selected-value');
    var checked=selectedInput(group);
    if(output&&checked){
      var value=String(checked.value||'').trim();
      if((output.textContent||'').trim()!==value) output.textContent=value;
      output.setAttribute('aria-live','polite');
    }
  }

  function enhanceColors(section,variants){
    section.querySelectorAll('[data-option-group],.product-option').forEach(function(group){
      var name=normalize(optionName(group));
      if(name.indexOf('color')===-1&&name.indexOf('colour')===-1) return;
      group.classList.add('product-option--color-reference');
      var position=group.getAttribute('data-option-position')||'1';
      group.querySelectorAll('input[data-variant-option],input[type="radio"]').forEach(function(input){
        var label=input.closest('.variant-box')||input.closest('label');
        if(!label) return;
        label.classList.add('variant-box--color-reference');
        label.setAttribute('title',input.value||'Color');
        if(!label.getAttribute('aria-label')) label.setAttribute('aria-label',input.value||'Color');
        var chip=label.querySelector('.variant-box__color-chip');
        if(!chip){
          chip=document.createElement('span');
          chip.className='variant-box__color-chip';
          chip.setAttribute('aria-hidden','true');
          var text=label.querySelector('.variant-box__text');
          if(text) label.insertBefore(chip,text);
          else label.appendChild(chip);
        }
        var image=swatchImage(variants,position,input.value);
        chip.style.backgroundColor=fallbackColor(input.value);
        if(image) chip.style.backgroundImage='url("'+String(image).replace(/"/g,'%22')+'")';
      });
      updateSelectedLabel(group);
      group.addEventListener('change',function(event){
        if(!event.target.matches('input[data-variant-option],input[type="radio"]')) return;
        window.requestAnimationFrame(function(){updateSelectedLabel(group);});
      });
      var output=group.querySelector('[data-option-label],.option-selected-value');
      if(output){
        new MutationObserver(function(){updateSelectedLabel(group);}).observe(output,{childList:true,characterData:true,subtree:true});
      }
    });
  }

  function availableSizes(group){
    var values=[];
    group.querySelectorAll('input[data-variant-option],input[type="radio"]').forEach(function(input){
      var v=String(input.value||'').trim();
      if(v&&values.indexOf(v)===-1) values.push(v);
    });
    return values;
  }

  function buildSizeGuide(section,sizeGroup){
    var existing=document.querySelector('[data-yyz-size-guide-for="'+(section.id||'product')+'"]');
    if(existing) return existing;

    var modal=document.createElement('div');
    var guideId='YYorrZSizeGuide-'+Math.random().toString(36).slice(2,9);
    var titleId=guideId+'-title';
    modal.className='yyz-size-guide-modal';
    modal.hidden=true;
    modal.setAttribute('data-yyz-size-guide-for',section.id||'product');
    modal.setAttribute('role','dialog');
    modal.setAttribute('aria-modal','true');
    modal.setAttribute('aria-labelledby',titleId);

    var sheet=document.createElement('div');
    sheet.className='yyz-size-guide__sheet';
    sheet.setAttribute('data-yyz-size-guide-sheet','');

    var close=document.createElement('button');
    close.type='button';
    close.className='yyz-size-guide__close';
    close.setAttribute('data-yyz-size-guide-close','');
    close.textContent='CLOSE';

    var inner=document.createElement('div');
    inner.className='yyz-size-guide__inner';

    var eyebrow=document.createElement('p');
    eyebrow.className='yyz-size-guide__eyebrow';
    var productTitle=section.querySelector('.product-title');
    eyebrow.textContent=productTitle?(productTitle.textContent||'').trim():'YYorrZ';

    var title=document.createElement('h2');
    title.className='yyz-size-guide__title';
    title.id=titleId;
    title.textContent='Size Guide';

    inner.appendChild(eyebrow);
    inner.appendChild(title);

    var accordionContent=section.querySelector('[data-product-accordion] [data-accordion-item] .accordion-panel__inner');
    if(accordionContent&&(accordionContent.textContent||'').trim()){
      var infoSection=document.createElement('section');
      infoSection.className='yyz-size-guide__section';
      var infoHeading=document.createElement('h3');
      infoHeading.textContent='Size & fit';
      var info=document.createElement('div');
      info.className='yyz-size-guide__content rte';
      info.innerHTML=accordionContent.innerHTML;
      infoSection.appendChild(infoHeading);
      infoSection.appendChild(info);
      inner.appendChild(infoSection);
    }

    var sizes=availableSizes(sizeGroup);
    if(sizes.length){
      var sizesSection=document.createElement('section');
      sizesSection.className='yyz-size-guide__section';
      var sizesHeading=document.createElement('h3');
      sizesHeading.textContent='Available sizes';
      var sizeRow=document.createElement('div');
      sizeRow.className='yyz-size-guide__sizes';
      sizes.forEach(function(value){
        var cell=document.createElement('span');
        cell.className='yyz-size-guide__size';
        cell.textContent=value;
        sizeRow.appendChild(cell);
      });
      sizesSection.appendChild(sizesHeading);
      sizesSection.appendChild(sizeRow);
      inner.appendChild(sizesSection);
    }

    var measureSection=document.createElement('section');
    measureSection.className='yyz-size-guide__section';
    var measureHeading=document.createElement('h3');
    measureHeading.textContent='How to measure';
    var measure=document.createElement('p');
    measure.className='yyz-size-guide__measure';
    measure.textContent='Use the product measurements shown above and compare them with a similar garment that fits you well. If product-specific measurements are not listed, use the available size options and fit information on this page.';
    measureSection.appendChild(measureHeading);
    measureSection.appendChild(measure);
    inner.appendChild(measureSection);

    sheet.appendChild(inner);
    modal.appendChild(sheet);
    modal.appendChild(close);
    document.body.appendChild(modal);
    return modal;
  }

  function wireSizeGuide(section,sizeGroup){
    if(sizeGroup.dataset.yyzSizeGuideReady==='true') return;
    sizeGroup.dataset.yyzSizeGuideReady='true';
    sizeGroup.classList.add('product-option--size-reference');
    var legend=sizeGroup.querySelector('.option-label')||sizeGroup.querySelector('legend');
    if(!legend) return;

    var trigger=document.createElement('button');
    trigger.type='button';
    trigger.className='yyz-size-guide-trigger';
    trigger.setAttribute('data-yyz-size-guide-open','');
    trigger.textContent='Size guide';
    legend.appendChild(trigger);

    var modal=buildSizeGuide(section,sizeGroup);
    var close=modal.querySelector('[data-yyz-size-guide-close]');
    var sheet=modal.querySelector('[data-yyz-size-guide-sheet]');
    var previousFocus=null;

    function openGuide(){
      previousFocus=document.activeElement;
      modal.hidden=false;
      document.body.classList.add('yyz-size-guide-open');
      if(sheet) sheet.scrollTop=0;
      window.requestAnimationFrame(function(){if(close) close.focus();});
    }

    function closeGuide(){
      modal.hidden=true;
      document.body.classList.remove('yyz-size-guide-open');
      if(previousFocus&&typeof previousFocus.focus==='function') previousFocus.focus();
    }

    trigger.addEventListener('click',function(event){event.preventDefault();openGuide();});
    if(close) close.addEventListener('click',closeGuide);
    modal.addEventListener('click',function(event){if(event.target===modal) closeGuide();});
    document.addEventListener('keydown',function(event){
      if(modal.hidden) return;
      if(event.key==='Escape'){event.preventDefault();closeGuide();return;}
      if(event.key==='Tab'){
        var focusable=modal.querySelectorAll('button:not([disabled]),a[href],input:not([disabled]),select:not([disabled]),textarea:not([disabled]),[tabindex]:not([tabindex="-1"])');
        if(!focusable.length) return;
        var first=focusable[0],last=focusable[focusable.length-1];
        if(event.shiftKey&&document.activeElement===first){event.preventDefault();last.focus();}
        else if(!event.shiftKey&&document.activeElement===last){event.preventDefault();first.focus();}
      }
    });
  }

  function enhanceSizes(section){
    section.querySelectorAll('[data-option-group],.product-option').forEach(function(group){
      if(normalize(optionName(group)).indexOf('size')===-1) return;
      wireSizeGuide(section,group);
    });
  }

  function moveCloseIntoInfo(section){
    var info=section.querySelector('.product-info');
    var close=section.querySelector('[data-yyz-product-close]');
    if(!info||!close) return;
    if(close.parentElement!==info) info.insertBefore(close,info.firstChild);
  }

  function enhanceSection(section){
    if(!section) return;
    injectStyles();
    moveCloseIntoInfo(section);
    var variants=readVariants(section);
    enhanceColors(section,variants);
    enhanceSizes(section);
    window.setTimeout(function(){moveCloseIntoInfo(section);},0);
  }

  function init(root){
    injectStyles();
    var scope=root||document;
    var sections=[];
    if(scope.matches&&scope.matches('[data-product-section]')) sections.push(scope);
    if(scope.querySelectorAll) scope.querySelectorAll('[data-product-section]').forEach(function(section){sections.push(section);});
    sections.forEach(enhanceSection);
  }

  function boot(){window.requestAnimationFrame(function(){init(document);});}
  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',boot,{once:true});
  else boot();
  document.addEventListener('shopify:section:load',function(event){window.requestAnimationFrame(function(){init(event.target);});});
})();
